import axios from 'axios';
import type { CreateResourceGoalParams, Curriculum, Goal } from '@ilteducation/curriculum-types';
import store from '@/store';

const getHeaders = () => ({
  'Content-Type': 'application/json',
});

export const getAllCurriculums = async (): Promise<Curriculum[]> =>
  axios
    .request({
      url: process.env.VUE_APP_CURRICULUMS_API_URL,
      method: 'GET',
      headers: getHeaders(),
    })
    .then((response) => response.data);

export const getAllCurriculumsGoals = async (curriculumId: string): Promise<Goal[]> =>
  axios
    .request({
      url: process.env['VUE_APP_CURRICULUM-GOALS_API_URL'],
      params: {
        curriculumId,
      },
      method: 'GET',
      headers: getHeaders(),
    })
    .then((response) => response.data);

export const createResourceGoal = async (resourceId: string, goalId: string): Promise<void> => {
  const data: CreateResourceGoalParams = { resourceId, goalId };
  store.commit('api/setLoading', true);
  try {
    await axios.request({
      url: process.env.VUE_APP_CURRICULUM_RESOURCE_GOALS_API_URL,
      method: 'POST',
      headers: getHeaders(),
      data,
    });
  } finally {
    store.commit('api/setLoading', false);
  }
};

export const deleteResourceGoal = async (resourceId: string, goalId: string): Promise<void> => {
  store.commit('api/setLoading', true);
  try {
    await axios.request({
      url: `${process.env.VUE_APP_CURRICULUM_RESOURCE_GOALS_API_URL}/${resourceId}/${goalId}`,
      method: 'DELETE',
      headers: getHeaders(),
    });
  } finally {
    store.commit('api/setLoading', false);
  }
};
